export const addToLocalStorage = (key, value) => {
    try {
        let dataToStore = value;
        if (value !== null && typeof value === 'object') {
            dataToStore = JSON.stringify(value);
        }
        localStorage.setItem(key, dataToStore);
    } catch (error) {
        console.error(`Error saving to localStorage with key "${key}":`, error);
    }
}

export const getFromLocalStorage = (key) => {
    const value = localStorage.getItem(key);
    if (value) {
        try {
            return JSON.parse(value);
        } catch (e) {
            return value;
        }
    }
    return null;
}

export const removeFromLocalStorage = (key) => {
    localStorage.removeItem(key);
}

export const clearLocalStorage = () => {
    localStorage.clear();
}

export const getValueAfterDashUsingRegex = (planName) => {
    const result = planName.replace(/.* - /, ''); // Regex removes everything before and including the dash
    return result;
}


// WEBPACK FOOTER //
// ./src/components/Billsby/utils.js